// Responsive UI eligibility, not device attestation or authorization.
// For touch-first tablets, the shorter physical CSS-screen dimension prevents
// a compact tablet from gaining access merely by rotating to landscape.
export const POS_DESKTOP_MIN_WIDTH = 1024;
export const POS_LARGE_TABLET_MIN_SIDE = 820;

export function isPosScreenEligible({ viewportWidth, screenWidth, screenHeight, touchPrimary }) {
  const width = Number(viewportWidth) || 0;
  if (!touchPrimary) return width >= POS_DESKTOP_MIN_WIDTH;
  const shortSide = Math.min(Number(screenWidth) || 0, Number(screenHeight) || 0);
  return shortSide >= POS_LARGE_TABLET_MIN_SIDE && width >= POS_LARGE_TABLET_MIN_SIDE;
}
